import { createContext } from 'react';

export type HandleRegistry = {
  register: (id: string, element: HTMLElement | null) => void;
};

// Lets a list focus a moved item's handle without looking it up in the document
export const HandleRegistryContext = createContext<HandleRegistry>({
  register: () => undefined,
});
